import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { routes } from './app.routes';
import { provideAzureAD } from './core/providers/authentication-provider';
import { provideOpenAPI } from './core/providers/openapi-provider';
import { provideTranslate } from './core/providers/translate-provider';
import { provideErrorNotifications } from './core/providers/error-notifications-provider';
import { NzConfig, provideNzConfig } from 'ng-zorro-antd/core/config';
import { NZ_DATE_CONFIG } from 'ng-zorro-antd/i18n';

const ngZorroConfig: NzConfig = {
  message: { nzTop: 10, nzDuration: 5000 },
};

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideNoopAnimations(),
    provideAzureAD(),
    provideOpenAPI(),
    provideTranslate(),
    provideErrorNotifications(),
    importProvidersFrom(),
    provideNzConfig(ngZorroConfig),
    {
      provide: NZ_DATE_CONFIG,
      useValue: { firstDayOfWeek: 1 },
    },
  ],
};
